import StoreEventNotesService from "@/api/services/storeEventNotes";

const initialState = {};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    noteTypes: () => () => {
      return ["call", "visio", "message", "visit", "other"];
    },
  },
  mutations: {},
  actions: {
    async create(_, { storeId, content, noteType }) {
      return StoreEventNotesService.create({ storeId, content, noteType });
    },
  },
};
